import React from 'react'
import { Button, Flex, Text } from 'rebass'
import { trackHandler, useIsSmallScreen } from 'uneeq-react-core'
import { ReactComponent as ExclamationIcon } from '../../assets/img/exclamation.svg'
import { ReactComponent as CloseIcon } from '../../assets/img/close.svg'
import { styles as s } from './styles'
const styles = s.error

interface ErrorProps {
  message?: string
  clearError?: () => void
}
const Error: React.FC<ErrorProps> = ({
  message = `An unknown error ocurred`,
  clearError
}) => {
  const isSmallScreen = useIsSmallScreen()

  return (
    <Flex
      sx={{
        ...styles.container,
        right: isSmallScreen ? '20px' : 77,
        top: isSmallScreen ? 'auto' : '50%',
        bottom: isSmallScreen ? '80px' : 'inherit',
        left: isSmallScreen ? '20px' : 'inherit',
        mt: isSmallScreen ? 0 : '-68px',
        width: isSmallScreen ? '90%' : 634
      }}
    >
      <Flex sx={styles.sideBorderError} />
      <Flex sx={styles.warning}>
        <Flex sx={styles.headingContainer}>
          <Flex sx={styles.icon}>
            <ExclamationIcon />
          </Flex>
          <Text sx={styles.heading}>Error</Text>
        </Flex>
        {clearError && (
          <Flex sx={styles.closeButtonContainer}>
            <Button
              sx={styles.closeButton}
              variant="unstyled"
              onClick={trackHandler(clearError, 'close-error-btn')}
            >
              <CloseIcon />
            </Button>
          </Flex>
        )}
        <Text sx={styles.message}>{message}</Text>
      </Flex>
    </Flex>
  )
}

export default Error
